import { useEffect } from 'react';

const useClearSessionFilter = (filterKey, excludedPathParts = []) => {
  useEffect(() => {
    const shouldClear = !excludedPathParts.some(part =>
      window.location.pathname.includes(part)
    );

    if (shouldClear && sessionStorage.getItem(filterKey)) {
      sessionStorage.removeItem(filterKey);
    }
  }, [window.location.pathname, filterKey, excludedPathParts]);
};

export default useClearSessionFilter;